import createReactClass from 'create-react-class';
'use strict';

// Import Libraries
import React from 'react';
import FocusTrap from 'focus-trap-react';

// -----------------------------------------------------------
//  MobileFiltersFullScreen
// -----------------------------------------------------------
var MobileFiltersFullScreen = createReactClass({
  displayName: 'Mobile Filters Full Screen',

  handleResetClick: function() {
    this.props.onClearAllFilters();
  },

  handleDoneClick: function() {
    this.props.onDoneClick();
  },

  render: function() {
    return (
      <FocusTrap active={ this.props.showMobileFiltersFullScreen } focusTrapOptions={{ returnFocusOnDeactivate: true }}>
        <div className="mobile-filters">
          <header>
            <div className="row">
              <div className="col reset-container">
                <button className="btn-secondary btn" onClick={this.handleResetClick}>Reset</button>
              </div>
              <div className="col done-container">
                <button className="btn-primary btn" onClick={this.handleDoneClick}>Done</button>
              </div>
            </div>
          </header>
          <main>
            {this.props.children}
          </main>
        </div>
      </FocusTrap>
   );
  }
});

export default MobileFiltersFullScreen;
